import React, { useEffect, useRef, useState } from 'react'
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import axios from 'axios';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';
import Select from 'react-select';
import { useUser } from "../../utils/userContext";
import moment from 'moment';


const AssignedAssestlist = () => {
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [assetList, setAssetList] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [loading, setLoading] = useState(false);
    const token = localStorage.getItem("token");
    const handleErrors = useHandleErrors();
    const hasFetchedRef = useRef(false);
    const [data, setData] = useState([]);
    const [asset, setasset] = useState('');
    const [isDropdownOpen, setIsDropdownOpen] = useState(true);
    const [employees, setEmployees] = useState([]);
    const { user } = useUser();
    const [formData, setFormData] = useState({
        Status: "",
        AssetHandoveredTo: "",
        Comments: "",
    });

    const getAssetReport = async () => {
        setLoading(true);
        try {
            const path = "/getAssetReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                const responseData = response.data.AssignAssets || [];
                setData(responseData);
                setFilteredData(responseData);
                const assetLists = response?.data?.AssignAssets?.map((asset) => {
                    return asset;
                });
                setAssetList(assetLists);
            } else if (response.status === 404) {
                setData([]); // Set data to an empty array
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    setData([]); // Set data to an empty array
                } else {
                    handleErrors(error.response);
                }
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (!hasFetchedRef.current) {
            getAssetReport()
            fetchEmployeeReport()
            hasFetchedRef.current = true;
        }
    }, []);

    const fetchEmployeeReport = async () => {
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;

            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            if (response.status === 200) {
                console.log("response", response);
                const activeEmployees = response.data.onboardEmployeeDetails?.filter(employee => employee.Status === 'Active');
                setEmployees(activeEmployees);
            }
            else {
                handleErrors(response)
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    }

    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Assets');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            const today = new Date();
            const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
            const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
            const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
            const formattedDate = `${year}${month}${day}`;
            link.download = `WW360-Assigned_Asset_Report_${formattedDate}.xlsx`;

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Assigned Asset List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Assets");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(blob, `WW360-Assigned_Asset_Report_${formattedDate}.xlsx`);
    };
    const shareData = {
        title: 'Assigned Asset List',
        text: 'Check out the Assigned Asset list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const handleDropdownClick = (record) => {
        console.log("record", record)
        setasset(record)
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    console.log("asset", asset)

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!formData.Status) {
            toast.error("Status is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        if (!formData.AssetHandoveredTo) {
            toast.error("Asset Handovered To is Required", {
                position: toast.POSITION.TOP_CENTER,
            });
            setLoading(false);
            return;
        }
        const selectedAssets = [{
            AssetId: asset.AssetId,
            CategoryType: asset.CategoryType,
            AssignDate: moment(asset.AssignDate).format("YYYY-MM-DD"),
            AssignmentType: asset.AssignmentType,
            SerialNumber: asset.SerialNumber,
        }]
        const payload = {
            EmployeeId: asset?.employeeId,
            AssetHandoveredTo: formData.handedOverTo,
            UpdatedBy: user?.EmployeeId,
            Comments: formData.Comments,
            AssetList: selectedAssets,
            Status: formData.Status,
            ActiveFlag: "N"
        };

        try {
            const path = "/assignAsset";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.post(URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json', // Ensure the Content-Type is set to application/json
                },
            });

            if (response.status === 200) {
                toast.success("Asset Updated successfully!", {
                    position: toast.POSITION.TOP_CENTER,
                });
                getAssetReport();
                setFormData({
                    Status: "",
                    AssetHandoveredTo: "",
                    Comments: "",
                });
                setIsDropdownOpen(true);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
            setTimeout(() => {
                const outsideClickElement = document.createElement('div');
                document.body.appendChild(outsideClickElement);
                outsideClickElement.click();
                document.body.removeChild(outsideClickElement);
            }, 100);
        }
    };


    const handleCancel = (e) => {
        e.preventDefault();
        setFormData({
            Status: "",
            AssetHandoveredTo: "",
            Comments: "",
        });
    };

    const employeeOptions = employees.map((emp) => ({
        value: emp.OfficialEmail,
        label: `${emp.OfficialEmail}`,
    }));

    const assetStatus = [
        { value: "Active", label: "Active" },
        { value: "InActive", label: "InActive" },
    ];

    const ClearIndicator = () => null;

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 500);
    }, []);

    useEffect(() => {
        // Filter employees based on the search query
        setFilteredData(
            assetList.filter(assetList =>
                assetList.employeeId.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assetList.AssetId.toLowerCase().includes(searchQuery.toLowerCase()) ||
                assetList.CategoryType.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery, assetList]);

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);


    const paginate = pageNumber => setCurrentPage(pageNumber);
    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Assigned Asset List</h3>
                        </div>
                        <div className="col-auto">
                            <Link to={'/AssignAssetList'} data-extra-toggle="tab" data-target="#employee-management-pan" className="btn btn-primary mt-lg-0 mt-4">
                                <i className="ri-user-add-line"></i> Assign Asset
                            </Link>
                        </div>
                    </div>
                    {data?.length === 0 ? (
                        <div class="container">
                            <div class="row vh-50 justify-content-center align-items-center">
                                <div class="col-auto">
                                    <div class="no-data-wrapper">
                                        <div class="no-data-found">
                                            <i class="ri-file-damage-fill"></i>
                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                            <p>No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row align-items-center justify-content-center mb-4">
                                <div className="col-lg-5 col-md-8 col-sm-10">
                                    <div className="container-fluid row-rounded mb-0">
                                        <div className="row px-2 py-0">
                                            <div className="input-group mb-0">
                                                <input
                                                    type="search"
                                                    className="form-control search-input"
                                                    placeholder="Keyword search..."
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                />
                                                <div className="input-group-append">
                                                    <button className="btn btn-primary" type="button" title="Search" rel="tooltip">
                                                        <i className="ri-menu-search-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <small className="form-text text-muted text-center mt-0">
                                        <i className="ri-information-2-fill text-info"></i> Allows: Employee ID - Asset ID - Category
                                    </small>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="card mb-4">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <h5 className="title mt-1 mb-0">Assigned Asset List</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button type="button" title="Email" rel="tooltip" className="btn btn-light btn-circle ml-2" onClick={() => sendEmail('')}>
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button type="button" title="Share" className="btn btn-light btn-circle ml-2" onClick={() => handleShare(filteredData)}>
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={exportToExcel}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive asset-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Asset ID</th>
                                                                    <th>Emp Id</th>
                                                                    <th>Emp Name</th>
                                                                    <th>Serial Number</th>
                                                                    <th>Category</th>
                                                                    <th>Assign Date</th>
                                                                    <th>Assignment Type</th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords?.map((record, index) => (
                                                                    <tr key={record.AssetId}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{record.AssetId}</td>
                                                                        <td>{record.employeeId}</td>
                                                                        <td>{record.employeeName}</td>
                                                                        <td>{record.SerialNumber}</td>
                                                                        <td>{record.CategoryType}</td>
                                                                        <td>{new Date(record.AssignDate).toLocaleDateString()}</td>
                                                                        <td>{record.AssignmentType}</td>
                                                                        <td className="text-center">
                                                                            <div className="dropdown" key={record.AssetId}>
                                                                                <button
                                                                                    className="btn btn-link text-info btn-action custom-dropdown-btn dropdown-toggle"
                                                                                    type="button"
                                                                                    id={`dropdownMenuButton-${record.AssetId}`}
                                                                                    data-toggle="dropdown"
                                                                                    aria-haspopup="true"
                                                                                    aria-expanded="false"
                                                                                    title="Update"
                                                                                    onClick={() => handleDropdownClick(record)}
                                                                                >
                                                                                    <i className="ri-list-settings-line"></i>
                                                                                </button>
                                                                                {isDropdownOpen ? (
                                                                                    <div
                                                                                        className="dropdown-menu dropdown-menu-right custom-dropdown shadow"
                                                                                        aria-labelledby={`dropdownMenuButton-${record.AssetId}`}
                                                                                    >
                                                                                        <form className="row" onSubmit={handleSubmit}>
                                                                                            <div className="form-group col-12" onClick={(e) => e.stopPropagation()}>
                                                                                                <label htmlFor="assetStatus" className="required">Status</label>
                                                                                                <Select
                                                                                                    className="react-select-container"
                                                                                                    classNamePrefix="react-select"
                                                                                                    name="Status"
                                                                                                    value={
                                                                                                        assetStatus.find(
                                                                                                            (option) => option.value === formData.Status
                                                                                                        ) || null
                                                                                                    }
                                                                                                    onChange={(selectedOption) =>
                                                                                                        setFormData({
                                                                                                            ...formData,
                                                                                                            Status: selectedOption ? selectedOption.value : "",
                                                                                                        })
                                                                                                    }
                                                                                                    options={assetStatus}
                                                                                                    components={{ ClearIndicator }}
                                                                                                    isClearable
                                                                                                    menuPortalTarget={document.body}
                                                                                                    styles={{
                                                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                                        control: base => ({ ...base, zIndex: 1 })
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="form-group col-md-12" onClick={(e) => e.stopPropagation()}>
                                                                                                <label htmlFor="assetCondition" className="required">Asset Handovered To</label>
                                                                                                <Select
                                                                                                    className="react-select-container"
                                                                                                    classNamePrefix="react-select"
                                                                                                    name="AssetHandoveredTo"
                                                                                                    value={
                                                                                                        employeeOptions.find(
                                                                                                            (option) => option.value === formData.AssetHandoveredTo
                                                                                                        ) || null
                                                                                                    }
                                                                                                    onChange={(selectedOption) =>
                                                                                                        setFormData({
                                                                                                            ...formData,
                                                                                                            AssetHandoveredTo: selectedOption ? selectedOption.value : "",
                                                                                                        })
                                                                                                    }
                                                                                                    options={employeeOptions}
                                                                                                    components={{ ClearIndicator }}
                                                                                                    isClearable
                                                                                                    menuPortalTarget={document.body}
                                                                                                    styles={{
                                                                                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                                                                        control: base => ({ ...base, zIndex: 1 })
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="form-group col-12">
                                                                                                <label htmlFor="Comments">Comments <small className="text-muted">(If any)</small></label>
                                                                                                <textarea
                                                                                                    id="Comments"
                                                                                                    name="Comments"
                                                                                                    className="form-control"
                                                                                                    rows="3"
                                                                                                    cols="5"
                                                                                                    value={formData.Comments}
                                                                                                    onChange={handleChange}
                                                                                                />
                                                                                            </div>
                                                                                            <div className="col-12 text-center">
                                                                                                <button type="reset" className="btn btn-light" onClick={handleCancel}>Cancel</button>
                                                                                                <button type="submit" className="btn btn-primary">
                                                                                                    Update <i className="ri-checkbox-circle-line"></i>
                                                                                                </button>
                                                                                            </div>
                                                                                        </form>
                                                                                    </div>
                                                                                ) : null}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default AssignedAssestlist
